import { render, staticRenderFns } from "./InstallationComponent.vue?vue&type=template&id=00666b4c"
import script from "./InstallationComponent.vue?vue&type=script&lang=js"
export * from "./InstallationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports